module.exports = "../../static/img/re.9c769f6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/re.svg
// module id = 926
// module chunks = 0